import SIDEBAR_MODEL from "./sidebar.model";

const getAccordionList = function (itemIds) {
  const str = JSON.stringify(SIDEBAR_MODEL);
  return JSON.parse(str).filter(it => {
    return itemIds.indexOf(it.id) > -1;
  });
};

const modusData = {
  active_modus: null,
  modusItems: [
    {
      img: "ansichtsmodus.svg",
      id: "ansichtsmodus",
      label: "Ansichts-Modus",
      viewKey: null,
      option: {
        key: "ansicht",
        openedAccordionId: "acco_kommentar",
        accordionList: getAccordionList(["acco_kommentar"]),
        urlparams: {
          merzId: null,
          seiteIdx: 0
        }
      }
    },
    {
      img: "untersuchungsmodus.svg",
      id: "untersuchungsmodus",
      label: "Untersuchungs-Modus",
      viewKey: null,
      option: {
        key: "untersuchung",
        accordionList: getAccordionList([
          "acco_inventarisierung",
          "acco_transkription",
          "acco_einzelstellenkommentare",
          "acco_uebersetzung",
          "acco_relation",
          "acco_orte",
          "acco_personen",
          "acco_themen"
        ]),
        openedAccordionId: "acco_inventarisierung",
        transparenz: 0,
        urlparams: {
          merzId: null,
          seiteIdx: null
        },
        popupBoxList: [],
        accoExpandPersonList: []
      }
    },
    {
      img: "vergleichsmodus.svg",
      id: "vergleichsmodus",
      label: "Vergleichs-Modus",
      viewKey: null,
      option: {
        key: "vergleich",
        accordionList: getAccordionList([
          "acco_inventarisierung",
          "acco_transkription",
          "acco_einzelstellenkommentare",
          "acco_uebersetzung",
          "acco_relation",
          "acco_orte",
          "acco_personen",
          "acco_seitenvorschau",
          "acco_themen"
        ]),
        openedAccordionId: "acco_uebersetzung",
        urlparams: {
          merzId: null,
          seiteIdx: null
        },
        popupBoxList: [],
        accoExpandPersonList: [],
        b: {
          key: "b_vergleich",
          accordionList: getAccordionList([
            "acco_inventarisierung",
            "acco_transkription",
            "acco_einzelstellenkommentare",
            "acco_uebersetzung",
            "acco_relation",
            "acco_orte",
            "acco_personen",
            "acco_seitenvorschau",
            "acco_themen"
          ]),
          openedAccordionId: "acco_uebersetzung",
          urlparams: {
            merzId: null,
            seiteIdx: null
          },
          popupBoxList: [],
          accoExpandPersonList: []
        }
      }
    },
    {
      img: "kompositionsmodus.svg",
      id: "kompositionsmodus",
      label: "Kompositions-Modus",
      viewKey: null,
      option: {
        key: "komposition",
        accordionList: getAccordionList(["acco_elementebibliothek"]),
        openedAccordionId: "acco_elementebibliothek",
        transparenz: 1,
        urlparams: {
          merzId: null,
          seiteIdx: null
        }
      }
    },
    {
      img: null,
      id: "simple",
      label: "Simple-Modus",
      viewKey: null,
      option: {
        key: "simple",
        accordionList: [],
        openedAccordionId: null,
        transparenz: 1,
        urlparams: {
        }
      }
    }
  ]
};

export const createNew = function (viewKey) {
  let str = JSON.stringify(modusData);

  // if (viewKey === 'werbe') {
    // str = str.replace(/Inventarisierung/g, 'Informationen');
  // }
  const data = JSON.parse(str);
  if (viewKey === 'ursonate_noten' || viewKey === 'ursonate_texte') {
    data.modusItems = data.modusItems.filter(d => d.id === 'simple');
  } else if (viewKey === 'werbe') {
    data.modusItems = data.modusItems.filter(d => d.id !== 'simple');
    data.modusItems.forEach(modus => {
      modus.option.accordionList = modus.option.accordionList.filter(acco => ['acco_kommentar', 'acco_inventarisierung'].indexOf(acco.id) > -1);
      if (modus.option.b) {
        modus.option.b.accordionList = modus.option.b.accordionList.filter(acco => ['acco_kommentar', 'acco_inventarisierung'].indexOf(acco.id) > -1);
      }
    });
  } else {
    data.modusItems = data.modusItems.filter(d => d.id !== 'simple');
  }

  data.modusItems.forEach(modus => {
    modus.option.viewKey = viewKey;
    if (modus.option.b) {
      modus.option.b.viewKey = viewKey;
    }
  });

  data.active_modus = data.modusItems[0];
  return data;
};



// WEBPACK FOOTER //
// ./src/store/datamodel/modus.model.js